import React, { useEffect, useState } from "react";
import { Box, Grid2, Stack, Typography } from "@mui/material";
import { asyncGet } from "../../../utils/httpRequests";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { formatDateDisplay, numeralCustom } from "../../../utils/helpers";
import { QRCodeSVG } from "qrcode.react";

function PrintVexePage() {
  const { id } = useParams();
  const app = useSelector((state: any) => state.app.data);
  const { token } = useSelector((state: any) => state.auth);
  const [data, setData] = useState<any>();

  const getData = async () => {
    const resp = await asyncGet({
      apiCode: "vexe",
      id: id as string,
      idApp: app?._id,
      token,
    });
    if (resp && resp?.status === 200) {
      setData(resp?.data);
    }
  };
  useEffect(() => {
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box sx={{ width: "100%", maxWidth: "419.53pt" }}>
      <Stack gap={1}>
        <Stack>
          <Typography variant="h6" sx={{ lineHeight: "20px" }}>
            {app?.name}
          </Typography>
          <Typography>Địa chỉ: {app?.address}</Typography>
          <Typography>Điện thoại: {app?.phone}</Typography>
        </Stack>
        <Typography variant="h3" sx={{ textAlign: "center" }}>
          VÉ XE KHÁCH
        </Typography>
        <Typography variant="h6" sx={{ textAlign: "center" }}>
          Tuyến đường: {data?.route_name}
        </Typography>
        <Box sx={{ mt: 1 }}>
          <Grid2 container spacing={1}>
            <Grid2 size={{ xs: 6 }}>
              <Typography>
                <Typography component="span" sx={{ fontWeight: 600 }}>
                  Mã đặt chỗ:
                </Typography>{" "}
                {data?.ma}
              </Typography>
            </Grid2>
            <Grid2 size={{ xs: 6 }}>
              <Typography>
                <Typography component="span" sx={{ fontWeight: 600 }}>
                  Số ghế:
                </Typography>{" "}
                {data?.ma_ghe}
              </Typography>
            </Grid2>
            <Grid2 size={{ xs: 6 }}>
              <Typography>
                <Typography component="span" sx={{ fontWeight: 600 }}>
                  Nhà xe:
                </Typography>{" "}
                {data?.ten_nha_xe}
              </Typography>
            </Grid2>
            <Grid2 size={{ xs: 6 }}>
              <Typography>
                <Typography component="span" sx={{ fontWeight: 600 }}>
                  Biển số:
                </Typography>{" "}
                {data?.bien_so}
              </Typography>
            </Grid2>
            <Grid2 size={{ xs: 6 }}>
              <Typography>
                <Typography component="span" sx={{ fontWeight: 600 }}>
                  Tên khách:
                </Typography>{" "}
                {data?.ten_kh}
              </Typography>
            </Grid2>
            <Grid2 size={{ xs: 6 }}>
              <Typography>
                <Typography component="span" sx={{ fontWeight: 600 }}>
                  Điện thoại:
                </Typography>{" "}
                {data?.sdt_kh}
              </Typography>
            </Grid2>
          </Grid2>
        </Box>

        <Typography>
          <Typography component="span" sx={{ fontWeight: 600 }}>
            Thời gian đi:
          </Typography>{" "}
          {formatDateDisplay(data?.tg_khoi_hanh, "HH:mm")} Ngày{" "}
          {formatDateDisplay(data?.tg_khoi_hanh, "DD/MM/YYYY")}
        </Typography>
        <Box>
          <Grid2 container spacing={2}>
            <Grid2 size={{ xs: 7 }}>
              <Stack justifyContent="center" sx={{ height: "100%" }}>
                <Typography variant="h4" sx={{ fontWeight: 600 }}>
                  GIÁ VÉ: {numeralCustom(data?.tien_tt_nt).format()} Đ/LƯỢT
                </Typography>
                <Typography sx={{ fontStyle: "italic" }}>
                  Ngày {formatDateDisplay(data?.tg_khoi_hanh, "DD")}, tháng{" "}
                  {formatDateDisplay(data?.tg_khoi_hanh, "MM")}, năm{" "}
                  {formatDateDisplay(data?.tg_khoi_hanh, "YYYY")} Bán vé
                </Typography>
              </Stack>
            </Grid2>
            <Grid2 size={{ xs: 5 }}>
              <Stack alignItems="center" sx={{ height: "100%" }}>
                <QRCodeSVG value={data?.ma} size={70} />
                <Typography sx={{ fontStyle: "italic" }}>
                  (Sử dụng mã này để được giảm giá khi ăn tại trạm)
                </Typography>
              </Stack>
            </Grid2>
          </Grid2>
        </Box>
      </Stack>
    </Box>
  );
}

export default PrintVexePage;
